import React from 'react';

const Header = () => {
  return (
    <header className="main-header">
      <div className="main-menu__top">
        <div className="main-menu__top-inner">
          <ul className="list-unstyled main-menu__contact-list">
            <li>
              <div className="icon">
                <i className="icon-email"></i>
              </div>
              <div className="text">
                <p><a href="mailto:info@rayyanaid.org">info@rayyanaid.org</a></p>
              </div>
            </li>
            <li>
              <div className="icon">
                <i className="icon-pin"></i>
              </div>
              <div className="text">
                <p>Abuja, Nigeria</p>
              </div>
            </li>
          </ul>
          <p className="main-menu__top-welcome-text">Welcome to Rayyan Aid — serving with dignity</p>
          <div className="main-menu__top-right">
            <p className="main-menu__social-title">Follow Us On:</p>
            <div className="main-menu__social">
              <a href="https://twitter.com/rayyanaid" target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>
              <a href="https://facebook.com/rayyanaid" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook"></i></a>
              <a href="https://www.pinterest.com/rayyanaid" target="_blank" rel="noopener noreferrer"><i className="fab fa-pinterest-p"></i></a>
              <a href="https://instagram.com/rayyanaid" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
            </div>
          </div>
        </div>
      </div>
      <nav className="main-menu">
        <div className="main-menu__wrapper">
          <div className="main-menu__wrapper-inner">
            <div className="main-menu__left">
              <div className="main-menu__logo">
                <a href="/"><img src="assets/images/Rayyan Aid Logo-03.png" alt="Rayyan Aid logo" style={{ height: '100px', width: 'auto', verticalAlign: 'middle' }} /></a>
                <a href="/" className="main-menu__brand" style={{ marginLeft: '0px', display: 'inline-block', verticalAlign: 'middle', fontWeight: 900, fontSize: '30px', color: '#ffffff', textDecoration: 'none' }}>Rayyan Aid</a>
              </div>
            </div>
            <div className="main-menu__main-menu-box">
              <a
                href="#"
                className="mobile-nav__toggler"
                onClick={(e) => {
                  e.preventDefault();
                  const wrapper = document.querySelector('.mobile-nav__wrapper');
                  if (wrapper) wrapper.classList.toggle('expanded');
                  document.body.classList.toggle('locked');
                }}
              >
                <i className="fa fa-bars"></i>
              </a>
              <ul className="main-menu__list">
                <li><a href="/">Home</a></li>
                <li><a href="/about">About</a></li>
                <li><a href="/donations">Donations</a></li>
                <li><a href="/contact">Contact</a></li>
              </ul>
            </div>
            <div className="main-menu__right">
              <div className="main-menu__call">
                <div className="main-menu__call-icon">
                  <i className="icon-call"></i>
                </div>
                <div className="main-menu__call-content">
                  {/* <p className="main-menu__call-sub-title">Call Anytime</p> */}
                  <h5 className="main-menu__call-number"><a href="tel:07063653772">07063653772</a></h5>
                </div>
              </div>
              <div className="main-menu__search-cart-box">
                <div className="main-menu__search-box">
                  <a href="#" className="main-menu__search searcher-toggler-box icon-search"></a>
                </div>
              </div>
              <div className="main-menu__nav-sidebar-icon">
                <a className="navSidebar-button" href="#">
                  <span className="icon-dots-menu-one"></span>
                  <span className="icon-dots-menu-two"></span>
                  <span className="icon-dots-menu-three"></span>
                </a>
              </div>
              <div className="main-menu__btn-box">
                <a href="/contact" className="thm-btn">
                  <span className="thm-btn-text">Donate Now</span>
                  <span className="thm-btn-icon-box"><i className="fas fa-arrow-right"></i></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;

